"use strict";
/**
 * Global Invoice API - Request Types
 *
 * Request types for the global invoice (Factura Global) endpoints.
 * Admin-only operations for generating, stamping, and managing
 * monthly consolidated invoices.
 *
 * @see /api/billing/global-invoices/*
 */
Object.defineProperty(exports, "__esModule", { value: true });
